import * as angular from "angular";
import {IPromise} from "angular";

export class AddressesDialogService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  routingSettings(event): IPromise<any>{
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/update-services-dialog.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (updateServices) => {
          self.$mdDialog.hide(updateServices);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.addresses')
  .service('addressesDialogService', AddressesDialogService);
